// ============== ！！！只需要改这里！！！ ===================
// 页面路由 => 测试 AppKey 映射
const PAGE_APPKEY_MAP = {
  "/xnhxwsxhv3": "qyzx01ac03a449dd8dd3262178458696",
  "/xnhxwsxhv3Thirty": "qyzxac5b7fc14660a6c8f800a729ee22",
  "/xnhxwsxhv3Quanzipublic": "qyzx84230f6840d1a57f3c545475b4d5"
};

const PAGE_CHANNEL_MAP = {
  "/xnhxwsxhv3": "00211FO",
  "/xnhxwsxhv3Thirty": "00211ZT",
  "/xnhxwsxhv3Quanzipublic": "00211ZU"
};
// 默认 AppKey
const DEFAULT_APPKEY = "qyzx01ac03a449dd8dd3262178458696";

// ==================== AES 加密配置 ====================
// 注意：AES 密钥需要向咪咕公司对接人获取
// 格式要求：16位（AES-128）、24位（AES-192）或32位（AES-256）
// 获取密钥后请替换下方的 AMBER_AES_KEY
const AMBER_AES_KEY = "migu_qingyuan123";  // 请向咪咕对接人获取
// ==========================================================

import qs from "qs";
import CryptoJS from "crypto-js";

// ==================== AES 加密工具函数 ====================
// 使用 crypto-js 实现 AES 加密（ECB 模式，PKCS7 填充）
function aesEncrypt(dataStr, secretKey) {
  if (!secretKey || secretKey.length !== 16) {
    console.warn("AES key 未配置或格式不正确（要求16位），跳过加密");
    return dataStr;
  }

  try {
    // 将密钥转换为 Utf8 格式
    const keyUtf8 = CryptoJS.enc.Utf8.parse(secretKey);

    // 执行加密
    // 模式：ECB（Electronic Codebook）
    // 填充：Pkcs7
    const encrypted = CryptoJS.AES.encrypt(dataStr, keyUtf8, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });

    // 返回 Base64 字符串（CipherParams 对象 toString() 默认返回 Base64）
    return encrypted.toString();
  } catch (e) {
    console.error("AES 加密失败:", e);
    return dataStr;
  }
}

// 脱敏处理：对敏感信息进行 AES 加密
function desensitizePhone(phone) {
  if (!phone || !AMBER_AES_KEY) {
    return phone;
  }
  return aesEncrypt(phone, AMBER_AES_KEY);
}

// 导出脱敏函数供外部使用
export { desensitizePhone };
// ==========================================================

// 环境基础配置（直接使用生产环境）
const BASE_CONF = {
  uploadUrl: "https://uem.migu.cn:18088/udcc/qyWebData.html",
  sdkUrl: "https://ambersdk.migu.cn/uemjs/xk/amber-web-sdk-min.js"
};

// 获取不带 base 前缀的路径（移除 /xnhdouyin）
function getRoutePath() {
  const fullPath = window.location.pathname;
  // 移除路由 base 前缀
  const basePath = "/xnhdouyin";
  if (fullPath.startsWith(basePath)) {
    return fullPath.substring(basePath.length) || fullPath;
  }
  return fullPath;
}

// 获取当前页面对应 AppKey
function getAppKeyByPage() {
  const path = getRoutePath();
  return PAGE_APPKEY_MAP[path] || DEFAULT_APPKEY;
}

// 最终配置
export const amberConfig = {
  ...BASE_CONF,
  accountId: getAppKeyByPage()
};

// 页面加载开始时间
let pageStartTime = Date.now();

// 埋点队列：用于缓存 SDK 加载完成前的埋点请求
let trackQueue = [];
// SDK 是否已经加载完成
let sdkReady = false;

// sdkTraceId 缓存：确保会话期间保持不变
let cachedSdkTraceId = "";

// 格式化值：对象类型保持原样，其他类型转换为字符串
function formatValue(value) {
  if (value === null || value === undefined) {
    return "";
  }
  if (typeof value === "object") {
    return value;  // 对象类型保持原样，不转换
  }
  return String(value);  // 基本类型转换为字符串
}

// SDK 加载完成后处理队列
function flushQueue() {
  if (!sdkReady || !window._amberTrack) return;

  while (trackQueue.length > 0) {
    const item = trackQueue.shift();

    // 重新获取公共参数（此时 SDK 已加载，可以获取 sdkTraceId，并且传入省市编码和手机号）
    const common = getCommon(item.phoneProvince, item.phoneCity, item.phoneNumber);
    const data = [];
    Object.keys(common).forEach((k) => data.push({ EK: k, EV: formatValue(common[k]) }));
    Object.keys(item.params).forEach((k) => data.push({ EK: k, EV: formatValue(item.params[k]) }));

    console.log("[Amber]", item.eventId, data);

    window._amberTrack(item.eventId, data);
  }
}

// 获取公共参数（独立函数，供 flushQueue 使用）
// phoneProvince/phoneCity: 可选参数，用于动态传入省市编码
// phoneNumber: 可选参数，原始手机号，有值时会自动加密作为 userId
function getCommon(phoneProvince = "", phoneCity = "", phoneNumber = "") {
  const u = qs.parse(location.search.replace("?", ""));

  // 获取 sdkTraceId：优先使用缓存，其次从 SDK 获取，最后从 URL 参数获取
  if (!cachedSdkTraceId) {
    // 尝试从 SDK 获取
    const sdkValue = (window.AmberWebSdk && window.AmberWebSdk.getSdkTraceId && window.AmberWebSdk.getSdkTraceId()) || "";
    // 尝试从 URL 参数获取
    const urlValue = u.sdkTraceId || "";
    // 设置缓存（优先使用 SDK 值）
    cachedSdkTraceId = sdkValue || urlValue;
  }

  // 构建公共参数
  const common = {
    sdkTraceId: cachedSdkTraceId,
    entrySource: u.entrySource || "",
    sourceType: u.sourceType || "1",
    sourcePlat: u.sourcePlat || "2",
    globalPlatform: "1",
    pageSeq: u.pageSeq || "1",
    channelId: PAGE_CHANNEL_MAP[getRoutePath()] || "",
    companyId: "MG002",
    companyName: "咪咕音乐",
    phoneProvince: phoneProvince,      // 公共字段：手机号码归属省份编码
    phoneCity: phoneCity               // 公共字段：手机号码归属地市编码
  };

  // 如果有手机号，自动加密作为 userId
  if (phoneNumber) {
    common.userId = desensitizePhone(phoneNumber);
  }

  return common;
}

// 监听 SDK 加载完成
window.addEventListener("amberReady", function() {
  sdkReady = true;
  flushQueue();
});

// 埋点工具
export default {
  // 获取公共参数（支持传入省市编码和手机号）
  getCommon(phoneProvince = "", phoneCity = "", phoneNumber = "") {
    return getCommon(phoneProvince, phoneCity, phoneNumber);
  },
  // 获取 sdkTraceId（供话费计费 SDK 初始化使用）
  getSdkTraceId() {
    return cachedSdkTraceId;
  },
  // 通用埋点方法（支持传入省市编码和手机号）
  track(eventId, params = {}, phoneProvince = "", phoneCity = "", phoneNumber = "") {
    // 获取公共参数（包含省市编码，如果有手机号会自动加密作为 userId）
    const common = this.getCommon(phoneProvince, phoneCity, phoneNumber);
    let data = [];
    Object.keys(common).forEach((k) => data.push({ EK: k, EV: formatValue(common[k]) }));
    Object.keys(params).forEach((k) => data.push({ EK: k, EV: formatValue(params[k]) }));

    // 调试日志：精简输出
    console.log("[Amber]", eventId, data);

    // 如果 SDK 已加载，直接上报
    if (sdkReady && window._amberTrack) {
      window._amberTrack(eventId, data);
    } else {
      // 如果 SDK 未加载，加入队列等待
      trackQueue.push({ eventId, params, phoneProvince, phoneCity, phoneNumber });
    }
  },
  // 页面加载
  pageLoad(loadTime) {
    const actualLoadTime = loadTime || (Date.now() - pageStartTime);
    this.track("qingyuan_page_load", { loadTime: actualLoadTime, resultCode: "0" });
  },
  // 页面停留
  pageStay(stayTime) {
    console.log("页面停留时长：", stayTime);
    this.track("qingyuan_page_stay", { stayTime });
  },
  // 登录（自动对敏感信息进行 AES 加密脱敏，支持传入手机号）
  userLogin(params, phoneNumber = "") {
    // 对参数中的敏感信息进行脱敏处理（account、phoneNumber）
    const processedParams = this.desensitizeParams(params);
    // 传入手机号，getCommon 会自动加密作为 userId
    this.track("qingyuan_user_login", processedParams, "", "", phoneNumber);
  },
  // 业务办理（自动对敏感信息进行 AES 加密脱敏，支持传入省市编码和手机号）
  traceLog(params, phoneProvince = "", phoneCity = "", phoneNumber = "") {
    // 对参数中的敏感信息进行脱敏处理
    const processedParams = this.desensitizeParams(params);
    // 调用 track 时传入省市编码和手机号，getCommon 会自动加密作为 userId
    this.track("qingyuan_traceLog", processedParams, phoneProvince, phoneCity, phoneNumber);
  },
  // 脱敏处理参数中的敏感信息
  desensitizeParams(params) {
    if (!params) return params;

    const result = { ...params };

    // ======== 文档要求的加密字段 ========
    // 2.1章节 userId、3.1章节 account、3.4章节 phoneNumber
    // 无论是否是手机号都做加密处理

    // 处理公共字段 userId
    if (result.userId) {
      result.userId = desensitizePhone(result.userId);
    }

    // 处理登录事件的 account
    if (result.account) {
      result.account = desensitizePhone(result.account);
    }

    // 处理 phoneNumber
    if (result.phoneNumber) {
      result.phoneNumber = desensitizePhone(result.phoneNumber);
    }

    // 处理 bussinessProcessing 中的 phoneNumber
    if (result.bussinessProcessing) {
      result.bussinessProcessing = { ...result.bussinessProcessing };

      if (result.bussinessProcessing.phoneNumber) {
        result.bussinessProcessing.phoneNumber = desensitizePhone(result.bussinessProcessing.phoneNumber);
      }
    }

    return result;
  },
  // 重置页面加载时间
  resetPageStartTime() {
    pageStartTime = Date.now();
  }
};



// WEBPACK FOOTER //
// ./src/utils/amber.js